module.exports = __webpack_public_path__ + "img/sp-icon-input-add.e917eadf.svg";